<template>
  <section class="">
    <!-- <div class="items-count">
      {{ count }} Products
    </div> -->
    <div v-if="debugging">
      Total: {{ productCount.total }}<br>
      Current: {{ productCount.current }}<br>
      Per Page: {{ productCount.perPage }}<br>
      Page: {{ productCount.page }}<br>
      Next: {{ productCount.next }}<br><br>
      Count: {{ count }}<br><br>
      Products so far: {{ productsSoFar }}
    </div>
    <div 
      v-if="noProductsFound" 
      class="no-products"
    >
      <h3>Sorry, your filter selections didn't return any results.</h3>
      <button 
        class="button"
        @click="resetFilters"
      >
        Reset Filters
      </button>
    </div>
    <ul
      v-else
      class="featured-items-group__content"
    >
      <template v-for="(product, index) in filteredItems">
        <li
          v-if="index < productsSoFar"
          :key="index"
        >
          <Product
            :product="product"
            :ecomm="product.isBuyNow"
          />
        </li>
      </template>
    </ul>
    <div class="view-more-container">
      <button
        v-if="productCount.current > productsSoFar && !noProductsFound"
        class="button"
        @click="addMoreTrends"
      >
        View {{ productCount.next }} More of {{ productsLeft }} {{ productsLeft > 1 ? 'Products' : 'Product' }}
      </button>
    </div>
  </section>
</template>

<script>
    import Product from "./items/Product.vue"

    import store from "../store"

    export default {
        name: "ProductsView",
        components: {
            Product
        },
        props: {
           noProductsFound: {
            type: Boolean,
            required: false,
            default: false,
          },
          page: {
            type: Number,
            required: false,
            default: null
          },
        },
        data() {
          return {
            productCount: {
              current: 0,
              total: 0,
              perPage: 20,
              page: 1,
              next: 0
            },
            debugging: false
          }
        },
        computed: {
          filteredItems: function() {
            const filtered = store.state.items.filter(i => {
              return !i.isExcluded
            })
            // console.log('filtered items: ', filtered)
            let buyNow = [];
            let nonBuyNow = []
           filtered.filter(i => {
              if(i.isBuyNow){
                buyNow.push(i)
              } else {
                nonBuyNow.push(i)
              }
            })
            return buyNow.concat(nonBuyNow)
          },
          count: function() {
            return this.filteredItems.length;
          },
          productsLeft: function() {
            return this.productCount.current - (this.productCount.perPage * this.productCount.page)
          },
          productsSoFar: function() {
            return this.productCount.perPage * this.productCount.page
          }
        },
        updated() {
          this.updateCounts()
        },
        mounted() {
          if(this.page){
            this.productCount.page = this.page
          }
        },
        created() {
          // this.productCount.total = this.count
          // this.productCount.current = this.count
          // this.productCount.next = (this.productCount.current >= this.productCount.perPage * (this.productCount.page + 1)) ? this.productCount.perPage : this.productCount.current - (this.productCount.perPage * this.productCount.page)
          this.updateCounts()
        },
        methods: {
          updateCounts: function() {
            // console.log('updateCounts')
            this.productCount.total = this.count
            this.productCount.current = this.count
            this.productCount.next = (this.productCount.current >= this.productCount.perPage * (this.productCount.page + 1)) ? this.productCount.perPage : this.productCount.current - (this.productCount.perPage * this.productCount.page)
            this.$emit('updateCount', this.count)
          },
          filteredTrends: function() {
              //console.log(this.$store.state.items);
              return this.$store.state.items.filter(function(item) {
                  return !item.isExcluded;
              });
          },
          addMoreTrends: function() {
            ++this.productCount.page
            // this.productCount.current = this.productCount.current + this.productCount.perPage
            // eslint-disable-next-line
            if (typeof dataLayer === 'object') {
              // eslint-disable-next-line
              dataLayer.push({
                event: 'genericEvent',
                eventCat: 'product engagement',
                eventAction: 'button click',
                eventLabel: 'View More Products',
              });
            }
            this.$router.push({path: this.$route.path, query: { page: this.productCount.page }})
          },
          incrementCounter: function(trend) {
            if (!trend.isExcluded) {
              this.liveCounter++
            }
            // console.log('liveCounter', this.liveCounter)
          },
          resetFilters: function(){
            this.$router.replace({query: null})
            this.$router.go({path: this.$route.path})
          }
        }
    };
</script>
